import { ALARM_PRIORITY } from "../ENUMS/PARAMETER_ENUM";
import { BED_DETAILS_MODULE, MODAL_ITEMS } from "../constant/common-constants";
import { useEffect } from "react";


export const handleOnFocusById = (id) => {

    try {
        document.getElementById(id).scrollIntoView({ block: "center", inline: "nearest" });
    } catch (error) {
        console.log("error occured in handleOnFocus!! ");
    }
}

export const handleOutsideClick = (event, id, setState) => {
    event.stopPropagation();
    setState(true);
    let element = document.getElementById(id);
    window.addEventListener('click', function (e) {
        if (element && element.contains(e.target)) {
        } else {
            setState(false);
        }
    });
}

export const handleScrollToTop = () => {
    window.scrollTo(0, 0);
}

export const handleScrollToBottom = (id) => {

    let ele = document.getElementById(id);
    if (ele) ele.scrollTop = ele.scrollHeight;
}

export const blurApp = () => {

    try {
        let elementList = document.getElementsByTagName("button");

        Array.from(elementList).forEach(function (element) {
            element.classList.add("pointer-event-none");
        });
        document.getElementById('App').classList.add('blur-with-pointer');
    } catch (err) {
        console.log("error occured in blurApp");
    }
}

export const unBlurApp = () => {

    try {
        let elementList = document.getElementsByTagName("button");

        Array.from(elementList).forEach(function (element) {
            element.classList.remove("pointer-event-none");
        });
        document.getElementById('App').classList.remove('blur-with-pointer');
    } catch (err) {
        console.log("error occured in unBlurApp");
    }
}

export const ConvertStringToHex = (hexString) => {
    var arr = [];
    for (var i = 0; i < hexString.length; i++) {
        arr[i] = ("00" + hexString.charCodeAt(i).toString(16)).slice(-4);
    }
    return "\\u" + arr.join("\\u");
}

export const getActiveModuleForBedDetails = (activeItem) => {

    switch (activeItem) {
        case MODAL_ITEMS.CHARTING:
            return BED_DETAILS_MODULE.CHARTING;
        case MODAL_ITEMS.NURSE_NOTES:
            return BED_DETAILS_MODULE.NURSE_NOTES;
        case MODAL_ITEMS.DOCTOR_NOTES:
            return BED_DETAILS_MODULE.DOCTOR_NOTES;
        case MODAL_ITEMS.PRESCRIPTION:
            return BED_DETAILS_MODULE.PRESCRIPTION;
        case MODAL_ITEMS.ALARM_HISTORY:
            return BED_DETAILS_MODULE.ALARMS;
        default:
            return BED_DETAILS_MODULE.PATIENT_DETAILS;
    }
}

export const getAlarmPriority = (priority) => {

    switch (priority) {
        case "HIGH":
            return 2;
        case "MEDIUM":
            return 1;
        case "LOW":
            return 0;
        default:
            return 0;
    }
}

export const alarmBackground = (alarms) => {
    // console.log(alarms)
    let backgroundColor = alarms?.[0]?.[1];
    alarms?.map((alarm) => {
        if (ALARM_PRIORITY[backgroundColor] > ALARM_PRIORITY[alarm?.[1]]) {
            backgroundColor = alarm?.[1];
        }
    });
    return backgroundColor ? (backgroundColor + '-priority') : '';
}

export const covertDateString = (observedTime) => observedTime?.slice(0, 4) + '-' + observedTime?.slice(4, 6) + '-' + observedTime?.slice(6, 8);

export const covertTimeString = (observedTime) => {
    return observedTime?.slice(8, 10) > 12 ?
        observedTime?.slice(8, 10) - 12 + ':' + observedTime?.slice(10, 12) + ':' + observedTime?.slice(12, 14) + 'PM'
        : observedTime?.slice(8, 10) == 12 ?
            observedTime?.slice(8, 10) + ':' + observedTime?.slice(10, 12) + ':' + observedTime?.slice(12, 14) + 'PM'
            :
            observedTime?.slice(8, 10) + ':' + observedTime?.slice(10, 12) + ':' + observedTime?.slice(12, 14) + 'AM'
}

export const convertUTCtoIST = (utcString) => {
    if (!utcString) return { time: '-', date: '-' };
    const date = new Date(utcString);

    // Format time in IST
    const time = date.toLocaleTimeString('en-IN', {
        timeZone: 'Asia/Kolkata',
        hour12: false,
        hour: '2-digit',
        minute: '2-digit',
        second: '2-digit',
    });

    // Format date in IST
    const formattedDate = date.toLocaleDateString('en-IN', {
        timeZone: 'Asia/Kolkata',
        day: '2-digit',
        month: '2-digit',
        year: 'numeric',
    });

    return { time, date: formattedDate };
};

export const formatValue = (id, num, precision = 0) => {
    if (num == null || isNaN(num)) return "--";

    const p = Math.pow(10, precision);

    // helper for string-based formatting
    const formatWithPrecision = (value) => {
        const [intPart, decPart = ""] = String(value).split(".");
        if (precision === 0) return intPart;
        return `${intPart}.${decPart.padEnd(precision, "0").slice(0, precision)}`;
    };

    if (id === 104005) {
        const iePrecision = 1;
        const ieP = Math.pow(10, iePrecision);

        const formatIEWithPrecision = (value) => {
            const [intPart, decPart = ""] = String(value).split(".");
            return `${intPart}.${decPart.padEnd(iePrecision, "0").slice(0, iePrecision)}`;
        };

        let roundedValue;

        if (num === 0) return "--";

        if (num <= 1) {
            roundedValue = Math.floor((1 / num) * ieP + 0.5) / ieP;
            return `1 : ${formatIEWithPrecision(roundedValue)}`;
        } else {
            roundedValue = Math.floor(num * ieP + 0.5) / ieP;
            return `${formatIEWithPrecision(roundedValue)} : 1`;
        }
    }

    // normal case for other IDs
    const rounded = Math.floor(num * p + 0.5) / p;
    return formatWithPrecision(rounded);
};


export const formatAlarmLimits = (num, id, patientType) => {
    if (id === 104009) {
        if (patientType === "neonatal") {
            num = num.toFixed(2);
        }
        else {
            num = num.toFixed(1);
        }
    }

    else if (id === 104008) {
        if (!isNaN(num) && num < 10) {
            num = num.toFixed(1);
        }
        else {
            num = Math.floor(num).toString();
        }
    }

    else {
        num = Math.floor(num).toString();
    }

    return num;
}

export const useClickOutside = (ref, handler, enabled = true) => {
    useEffect(() => {
        if (!enabled) return;

        const listener = (event) => {
            if (!ref.current || ref.current.contains(event.target)) {
                return;
            }
            handler(event);
        };

        document.addEventListener("mousedown", listener);
        document.addEventListener("touchstart", listener); // mobile support

        return () => {
            document.removeEventListener("mousedown", listener);
            document.removeEventListener("touchstart", listener);
        };
    }, [ref, handler, enabled]);
};



